import React from 'react';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import ctypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import { injectIntl } from 'react-intl';


class FlexSearchHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getTabs = ({ data }) => {
        let tabs = [];
        data.map(item => {
            if (item.tab) tabs.push({ "name": item.tab, "lgMsId": item.tab });
        });
        tabs = tabs.reduce((acc, item) => {
            if (!acc.find(el => el.name == item.name)) acc.push(item);
            return acc;
        }, []);
        return tabs;
    }

    checkSearchData = ({ data }) => {
        let expertSearchConfig = [];
        let formTabs = this.getTabs({ data: data });
        expertSearchConfig = CustomForm.initFormDataForApp({
            formName: ctypes.APP_FORM_SEARCH, formData: data, formTabs,
            user: this.props.user, users: this.props.users, lg: this.props.lg
        });
        if (expertSearchConfig) {
            expertSearchConfig = expertSearchConfig.map(item => {
                if (item.data && item.data.length) {
                    item.data = item.data.map(el => {
                        if (!el.inputType) el.inputType = "CustomDataInput";
                        return el;
                    });
                }
                return item;
            });
            this.props.addApiExpertSearchConfig(expertSearchConfig);
        }
    }

    checkAllConfig = ({ item, ddvalue }) => {
        let ddvalueArr = ddvalue.split(";");
        if (item.params && item.params.condition && item.params.condition.content) {
            let contentArr = item.params.condition.content;
            if (typeof contentArr === 'string') contentArr = contentArr.split(",");
            if (contentArr && contentArr.length) {
                let found = false;
                contentArr.forEach(ct => {
                    if (ddvalueArr.find(v => v == ct)) found = true;
                })
                if (found) return true
            }
        }
        return false;
    }

    handleFlex = ({ ddname, ddvalue }) => {
        let clipConfig;
        if (this.props.meta && this.props.meta.clip) {
            clipConfig = [...this.props.meta.clip];
            if (ddvalue && ddvalue.trim()) {
                clipConfig = this.props.meta.clip.filter(item => {
                    if (item.field === ddname) return true;
                    if (this.checkAllConfig({ item, ddvalue })) return true;
                    if (item.search && (!item.params
                        || (item.params && (!item.params.condition
                            || (item.params.condition && !item.params.condition.content))))) {
                        return true;
                    }
                    return false;
                });
                if (clipConfig && clipConfig.length) {
                    clipConfig = clipConfig.map(item => ({ ...item, search: true }));
                }
                //console.log("LOGS: LAMTEST clipConfig", clipConfig);
                //Search
                this.checkSearchData({ data: clipConfig });
            } else {
                this.checkSearchData({ data: this.props.meta.clip });
            }
        }
    }

    initData = () => {
        if (this.props.user && this.props.user.granting && this.props.user.granting.udo
            && this.props.user.granting.udo.lastsearchdata) {
            let last = this.props.user.granting.udo.lastsearchdata;
            let ddname, ddvalue;
            for (let i in last) {
                if (i == ctypes.MBOX) {
                    ddname = ctypes.MBOX;
                    ddvalue = last[i]
                } else if (i == `${ctypes.MBOX}Items`) {
                    if (last[i] && last[i].length) {
                        ddname = ctypes.MBOX;
                        ddvalue = last[i][0].ID;
                    }
                }
            }
            if (ddname) setTimeout(() => this.handleFlex({ ddname, ddvalue }), 1500);
        }
    }

    componentDidUpdate(prev) {
        const { flexMulti } = this.props.flexObjects;
        if (prev.flexObjects.flexMulti !== flexMulti) {
            if (flexMulti && flexMulti.ddname === ctypes.MBOX) {
                this.handleFlex({ ...flexMulti });
            }
        }
    }

    componentDidMount() {
        this.initData();
        setTimeout(() => this.checkSearchData({ data: this.props.meta.clip }), 500);
    }

    render() {
        if (DataUtil.isPorscheArchiv() || DataUtil.isDZA()) {
            return (
                <div className="FlexSearchHandler">
                </div>)
        }
        return null;
    }
}

const mapStateToprops = (state) => ({
    flexObjects: state.flex.flexObjects,
    loading: state.flex.loading,
    meta: state.metadata.config,
    users: state.admin.users,
    user: state.auth.user,
    lg: state.ui.language,
})

const mapDispatchToProps = (dispatch) => ({
    updateFlexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
    addApiExpertSearchConfig: (expertSearchConfig) => dispatch(actions.addApiExpertSearchConfig(expertSearchConfig)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FlexSearchHandler));